export default "__VITE_ASSET__CN1HG2Y4__"